export const payloadPartnerCoSite: any = {
  locale: "en_US",
  perPage: "20",
  start: 20
};








